// extracted by mini-css-extract-plugin
export default {"root":"_2pj9-","cover":"_3TqrC","middle":"_27Mnw","underlay":"_3qgDV"};